// Scope variant:change listener to each product-form that owns a data-atc-wrapper.
// Listening on document catches variant:change events from Rebuy/other recommendation
// widgets on the page, whose in-stock variants incorrectly hide our BIS button.
document.querySelectorAll('[data-atc-wrapper]').forEach(function (atcWrapper) {
  var productForm = atcWrapper.closest('product-form');
  if (!productForm) return;

  var bisWrapper = productForm.nextElementSibling;
  if (!bisWrapper || !bisWrapper.hasAttribute('data-bis-wrapper')) return;

  productForm.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    var isOOS = !variant || !variant.available;
    atcWrapper.hidden = isOOS;
    bisWrapper.hidden = !isOOS;
  });
});

// Delegate clicks on our styled button to Klaviyo's hidden BIS button.
// Klaviyo replaces .klaviyo-bis-trigger elements with #klaviyo-bis-button-container.
// We keep that container hidden via CSS and proxy clicks through it so Klaviyo
// opens its modal with the correct variant context.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-bis-open]');
  if (!btn) return;
  var klaviyoBtn = document.querySelector('#klaviyo-bis-button-container button');
  if (klaviyoBtn) {
    klaviyoBtn.click();
  }
});
